module.exports = __webpack_public_path__ + "static/media/buryTheCards_ru.9b95e975.svg";